import { useMemo } from 'react'
import { selectInProgressCookingProgresses, useAppSelector, useT, type Recipe } from '@reciperoll/core'
import { RecipeListItem } from './RecipeListItem'

interface RecipeListProps {
  recipes: Recipe[]
  emptyMessage?: string
  // recipeId -> matched ingredient names (from a search), shown highlighted.
  matchedIngredients?: Record<string, string[]>
}

export function RecipeList({
  recipes,
  emptyMessage,
  matchedIngredients,
}: RecipeListProps) {
  const t = useT()
  const inProgress = useAppSelector(selectInProgressCookingProgresses)
  const cookingIds = useMemo(() => new Set(inProgress.map((cp) => cp.recipeId)), [inProgress])

  if (recipes.length === 0) {
    return <p className="text-ink-faint text-sm px-1">{emptyMessage ?? t('library.emptyDefault')}</p>
  }

  return (
    <div className="flex flex-col gap-2.5">
      {recipes.map((recipe) => (
        <RecipeListItem
          key={recipe.id}
          recipe={recipe}
          matches={matchedIngredients?.[recipe.id]}
          isCooking={cookingIds.has(recipe.id)}
        />
      ))}
    </div>
  )
}
